var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconToolBarNumberLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icon_ToolBar_NumberLine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 195"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 64",
    x: 2.38623,
    y: 44.6752,
    width: 58,
    height: 15,
    rx: 2,
    fill: "#8F84DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M2.38623 40.9572C12.4053 12.8998 33.4277 -27.6591 59.3862 39.6782",
    stroke: "#8F84DE",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M52 38.8462L61.1 43L65 34L52 38.8462Z",
    fill: "#8F84DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolBarNumberLine);
export default __webpack_public_path__ + "static/media/Icon_ToolBar_NumberLine.3aa6e82ffc577adbd271973c80d2b1f9.svg";
export { ForwardRef as ReactComponent };